// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","720":"component---src-pages-danger-tsx"}[chunkId] + "-" + {"218":"d698170794112513d14e","691":"4ce56b0e96c4101d6b45","720":"1519bc5a368ef5d41811"}[chunkId] + ".js";
};